import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (project) =>
    present(
      repository
        .removeProject(project)
        .then(() => project)
        .catch((error) => Promise.reject({ error, project })),
    );
}

export type { Interactor };

export { createInteractor };
